import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Vehicle } from '@polaris-customerweb/sharedcomponents.garage';
import { VehicleMakeInfo } from './models/industry-dropdowns.model';
import { VehicleState, vehicleFeatureKey } from './vehicle.reducer';

export const vehicleState =
    createFeatureSelector<VehicleState>(vehicleFeatureKey);
export const selectAreVehiclesLoaded = createSelector(
    vehicleState,
    (state) => state.areVehiclesLoaded
);
export const selectVehiclesForUser = createSelector(
    vehicleState,
    (state) => state.vehiclesForUser
);
export const selectVinsForUser = createSelector(
    selectVehiclesForUser,
    (vehicles) => vehicles.map((vehicle) => vehicle.vin)
);
export const selectVinToVehicleMap = createSelector(
    selectVehiclesForUser,
    (vehicles) =>
        vehicles.reduce<Record<string, Vehicle | undefined>>(
            (vinToIdMap, vehicle) => {
                vinToIdMap[vehicle.vin] = vehicle;
                return vinToIdMap;
            },
            {}
        )
);
export const selectActiveVehicleId = createSelector(
    vehicleState,
    (state) => state.activeVehicleId
);
export const selectActiveVehicle = createSelector(
    selectVehiclesForUser,
    selectActiveVehicleId,
    (vehicles, selectedId) => {
        return vehicles.find((vehicle) => vehicle.id === selectedId);
    }
);
export const selectActiveVehicleAlertsEnabled = createSelector(
    selectActiveVehicle,
    (vehicle) => {
        return !vehicle?.bumpAlertDisabled || !vehicle.theftAlertDisabled;
    }
);

export const selectVehicleCategories = createSelector(vehicleState, (state) =>
    state.vehicleCategories.data?.categories.map((category) => {
        let name = category.categoryDisplayName;
        if (name === 'Auto Cycle') {
            name = 'Slingshot';
        }
        return {
            id: category.categoryID,
            imageId: name.split(' ').join('-').toLowerCase(),
            name,
        };
    })
);

export const selectVehicleMakes = createSelector(vehicleState, (state) => {
    const selectedCategory = state.vehicleMakes.selectedCategoryId;
    return state.vehicleMakes.entities[selectedCategory]?.getMakesResult
        .reduce<VehicleMakeInfo[]>((result, current) => {
            result.push(...current.makes);
            return result;
        }, [])
        .map((make) => {
            return {
                id: make.makeID,
                imageId: make.makeDisplayName
                    .split(' ')
                    .join('-')
                    .toLowerCase(),
                isPolaris: make.isPolarisMake,
                name: make.makeDisplayName,
            };
        });
});

export const selectVehicleYears = createSelector(vehicleState, (state) => {
    const selectedMakeId = state.vehicleYears.selectedMakeId;
    return state.vehicleYears.entities[selectedMakeId]?.years.map((year) => {
        return +year;
    });
});

export const selectVehicleModels = createSelector(vehicleState, (state) => {
    const selectedMakeYear = state.vehicleModels.selectedMakeYearId;
    return state.vehicleModels.entities[
        selectedMakeYear
    ]?.getModelTrimsResult.modelTrims.map((model) => {
        return {
            id: model.modelID,
            name: model.modelName,
        };
    });
});
